module.exports = __webpack_public_path__ + "img/29.8c84ec34.jpg";